import(/* webpackMode: "eager", webpackExports: ["SupportPage"] */ "/home/ec2-user/ennix-electronics/src/app/support/_components/SupportPage.jsx");
